export const DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER'
export const INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER'

// Language
export const UPDATE_LOCALE = 'UPDATE_LOCALE'

// Filters
export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const ADD_TYPE = 'ADD_GROUP'
export const REMOVE_TYPE = 'REMOVE_GROUP'
export const UPDATE_TYPES = 'UPDATE_TYPES'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js